import gql from 'graphql-tag';

export const GET_PACKAGES = gql`
  query Packages {
    getAllSubsciptionPackages {
      _id
      title
      currency
      duration
      description
      pricing
      isActive
      type
    }
  }
`;
